// import { DEFAULT_LAYOUT } from 'src/constants/common';
import { CustomDropdownValues } from 'types/qa.types';

export const PAGE_NAME = 'addSku';
export const OVERRIDE_BASE_PRICE_DISCLAIMER = '*Discount will be applied at checkout';

export const REMOTE_QUESTION = {
  id: 'remote',
  textDirect: 'Do you want <i class="ht-icon ht-logo-HellotechNow -hellotech-now"></i>?',
  inputType: 'dropdown',
  required: true,
  answers: [
    {
      id: 'remote-true',
      text: 'Yes (Save %{SAVING}% with instant online support)',
      adjAmount: 0,
      adjAmountFormatted: null,
      adjDescription: 'HelloTech Now!',
      hasQuantity: false,
      default: true,
      warning: null,
    },
    {
      id: 'remote-false',
      text: 'No, I want in-home service',
      adjAmount: 0,
      adjAmountFormatted: null,
      adjDescription: 'HelloTech Now!',
      hasQuantity: false,
      default: true,
      warning: null,
    },
  ],
};

export const REMOTE = 'remote';
export const REMOTE_TRUE = 'remote-true';

export const CUSTOM_DROPDOWN_OPTIONS = {
  I_DONT_KNOW: { value: CustomDropdownValues.negOne, label: "I don't know", searchable: false },
  OTHER: { value: CustomDropdownValues.empty, label: 'Other', searchable: false },
  NO_OPTIONS: { value: CustomDropdownValues.zero, label: 'Sorry, we were unable to find a match', isDisabled: true, searchable: false },
} as const;
